import { Controller } from "@hotwired/stimulus"
import { pulseStep } from "../lib/tally"

// Only fixed lesson/tool names and the action go to Pulse, never a sample's inputs.
export default class extends Controller {
  static values = { lesson: String, tools: Array }

  connect() {
    this.step("learn-open")
  }

  try(event) {
    if (event.target.closest("[data-learn-sample]")) this.step("learn-try")
  }

  pick(event) {
    const link = event.target.closest("a[data-learn-tool]")
    if (!link) {
      if (event.target.closest("[data-learn-sample] button")) this.step("learn-try")
      return
    }
    const { learnTool: tool, learnHow: how, learnFrom: from } = link.dataset
    if (this.toolsValue.includes(tool) && ["open", "trial"].includes(how) && ["result", "tools"].includes(from)) {
      this.step("learn-go", { tool, how, from })
    }
  }

  step(name, data = {}) {
    pulseStep(name, { lesson: this.lessonValue, surface: "public", ...data }, { once: true })
  }
}
